(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.innerContainer = this.querySelector('.announcement-bar__inner');
      this.slides = this.innerContainer ? Array.from(this.innerContainer.querySelectorAll('.announcement-bar__row')) : [];
      this.currentIndex = 0;
      this.timerId = null;

      this.isCarouselEnabled = this.dataset.enableCarousel === 'true';
      this.isAutoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
    }

    connectedCallback() {
      this.handleCloseButtons();

      if (this.isCarouselEnabled && this.slides.length > 1) {
        this.initCarousel();
      } else {
        this.slides.forEach((slide) => {
          slide.style.position = 'relative';
          slide.style.opacity = '1';
          slide.style.visibility = 'visible';
        });
        if (this.slides.length > 0 && !this.slides[0].classList.contains('is-active')) {
        }
      }
    }
    initCarousel() {
      if (this.slides.length === 0) return;
      
      const initiallyActiveSlideIndex = this.slides.findIndex(slide => slide.classList.contains('is-active'));
      if (initiallyActiveSlideIndex !== -1) {
        this.currentIndex = initiallyActiveSlideIndex;
      } else if (this.slides.length > 0) {
        this.slides[0].classList.add('is-active');
        this.currentIndex = 0;
      }

      
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.classList.remove('is-active');
        }
      });

      if (this.isAutoplayEnabled) {
        this.startAutoplay();
        if (this.innerContainer) {
          this.innerContainer.addEventListener('mouseenter', this.pauseAutoplay.bind(this));
          this.innerContainer.addEventListener('mouseleave', this.startAutoplay.bind(this));
        }
      }
    }

    showSlide(index) {
      if (this.slides.length === 0 || index === this.currentIndex && this.slides[index].classList.contains('is-active')) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides[this.currentIndex].classList.add('is-active');
    }

    nextSlide() {
      this.showSlide(this.currentIndex + 1);
    }

    startAutoplay() {
      if (!this.isAutoplayEnabled || this.slides.length <= 1) return;
      this.pauseAutoplay(); 
      this.timerId = setInterval(() => {
        this.nextSlide();
      }, this.autoplaySpeed);
    }

    pauseAutoplay() {
      clearInterval(this.timerId);
    }

    handleCloseButtons() {
      const barCloseButton = this.querySelector('[data-close-announcement="bar"]');
      if (barCloseButton) {
        barCloseButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.removeBar();
        });
      }

      
      
      if (!this.isCarouselEnabled) {
        this.slides.forEach(slide => {
          const rowCloseButton = slide.querySelector('[data-close-announcement="row"]');
          if (rowCloseButton) {
            rowCloseButton.addEventListener('click', (e) => {
              e.preventDefault();
              slide.remove();
              
              this.slides = this.slides.filter(s => s !== slide);
              if (this.slides.length === 0) {
                this.removeBar();
              }
            });
          }
        });
      }
    }

    removeBar() {
      this.pauseAutoplay();
      this.remove();
    }

    disconnectedCallback() {
      this.pauseAutoplay();
      if (this.innerContainer) {
        this.innerContainer.removeEventListener('mouseenter', this.pauseAutoplay.bind(this));
        this.innerContainer.removeEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();
})();
